import { FC } from 'react';
import {
	Text,
	Accordion,
	Badge,
	NumberInput,
	NumberInputProps,
} from '@mantine/core';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { useContent } from '@/providers/ContentProvider';
import APP_CONFIG from '@/configs/appConfig';

const baseSlug = 'creator.';

export const SiphonsQuantity: FC = () => {
	const dispatch = useTypedDispatch();

	const { getContent } = useContent();

	const { product, siphons, length } = useTypedSelector((app) => app.creator);

	const handleChange: NumberInputProps['onChange'] = (value) => {
		dispatch(creatorActions.setSiphonsQuantity(Number(value)));
	};

	const max = Math.ceil(APP_CONFIG.SIPHONS.MAX_PER_1000_MM * (length / 1000));

	return (
		<Accordion.Item value="siphon-quantity">
			<Accordion.Control
				disabled={!product}
				icon={
					!!siphons.length && (
						<Badge>
							<Text size="sm" fw="bold">
								{siphons.length} szt.
							</Text>
						</Badge>
					)
				}
			>
				{getContent(`${baseSlug}fifthOption.name`)}
			</Accordion.Control>
			<Accordion.Panel>
				<Text mb="md">
					Na podstawie długości odpływu wyznaczyliśmy maksymalną liczbę
					możliwych do umieszczenia syfonów: <strong>{max}</strong>.
				</Text>
				<NumberInput
					w="100%"
					placeholder="Liczba syfonów"
					suffix=" szt."
					value={siphons.length}
					clampBehavior="strict"
					onChange={handleChange}
					min={APP_CONFIG.SIPHONS.MIN}
					max={max}
				/>
			</Accordion.Panel>
		</Accordion.Item>
	);
};
